import Icon from 'components/atoms/Icon';
import { useScheduledCandidateUsageCsvFileExportMutation } from 'generated/graphql';
import { FC } from 'react';
import {
  Button,
  TMultiselectOption,
  TNotification,
  useNotification,
} from '@spotted-zebra-uk/ui-components';
import { TFormValues } from '../CandidateUsage';

interface IExportResult {
  getQueryVariablesFromFormValues: (
    companies: TMultiselectOption[],
    dateFrom: string,
    dateTo: string
  ) => [number[], string, string];
  formValues: TFormValues;
  disabled: boolean;
}

const ExportResult: FC<IExportResult> = ({
  getQueryVariablesFromFormValues,
  formValues,
  disabled,
}) => {
  const { handleMsgType } = useNotification();

  const [scheduleCandidateUsageCsvFileExport, { loading: loadingExport }] =
    useScheduledCandidateUsageCsvFileExportMutation({
      onError: error => {
        handleMsgType({
          type: TNotification.error,
          title: 'Something went wrong',
          message: `${error.message}`,
          dismissable: true,
        });
      },
      onCompleted: () => {
        handleMsgType({
          type: TNotification.success,
          title: 'Successfully requested export!',
          dismissable: true,
        });
      },
    });

  const handleExportResultClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    const { companies, dateFrom, dateTo } = formValues;
    const [companyIds, startOfDayStartDate, endOfDayEndDate] =
      getQueryVariablesFromFormValues(companies, dateFrom, dateTo);
    scheduleCandidateUsageCsvFileExport({
      variables: {
        companyIds,
        createdAtFrom: startOfDayStartDate,
        createdAtTo: endOfDayEndDate,
      },
    });
  };

  return (
    <Button
      size="large"
      variant="primary"
      disabled={disabled || loadingExport}
      data-testid="company-projects-button-export-result"
      onClick={handleExportResultClick}
      leftIcon={<Icon icon="export_icon" />}
    >
      {loadingExport ? 'Exporting...' : 'Export results'}
    </Button>
  );
};

export default ExportResult;
